module.exports = __webpack_public_path__ + "media/images/business/i-file-18af4f5fe21ba766539c0f40ac61aaed.svg";